export const data = [
  {
    question: "What's your ideal everyday outfit?",
    option1:
      "A vintage-inspired mini dress with cute shoes and a bow in your hair",
    option1Celeb: "Sabrina Carpenter",
    option2: "An all-black ensemble with a structured blazer and sleek boots",
    option2Celeb: "Jenna Ortega",
    option3:
      "A crisp white shirt with high-waisted jeans and minimalist jewelry",
    option3Celeb: "Alexandra Saint Mleux",
    option4: "A bold crop top with baggy jeans and sneakers",
    option4Celeb: "Katseye",
  },
  {
    question: "How would your friends describe your style?",
    option1: "Playfully romantic with a touch of old Hollywood glamour",
    option1Celeb: "Sabrina Carpenter",
    option2: "Edgy and sophisticated with a dark, mysterious edge",
    option2Celeb: "Jenna Ortega",
    option3: "Effortlessly chic with timeless European elegance",
    option3Celeb: "Alexandra Saint Mleux",
    option4: "Bold and experimental with fun Y2K vibes",
    option4Celeb: "Katseye",
  },
  {
    question: "What's your dream red carpet look?",
    option1: "A sparkly cocktail dress with vintage curls and red lips",
    option1Celeb: "Sabrina Carpenter",
    option2: "A dramatic black gown with gothic details and bold makeup",
    option2Celeb: "Jenna Ortega",
    option3: "A sleek dress in a neutral tone with clean girl makeup",
    option3Celeb: "Alexandra Saint Mleux",
    option4: "A futuristic metallic set with statement accessories and glitter",
    option4Celeb: "Katseye",
  },
  {
    question: "Pick your ideal fashion destination:",
    option1: "Los Angeles (vintage shopping and rooftop brunches)",
    option1Celeb: "Sabrina Carpenter",
    option2: "New York City (gothic architecture and downtown cool vibes)",
    option2Celeb: "Jenna Ortega",
    option3: "Paris or Monaco (café hopping and quiet luxury)",
    option3Celeb: "Alexandra Saint Mleux",
    option4: "Tokyo or Seoul (cutting-edge street style and K-fashion)",
    option4Celeb: "Katseye",
  },
  {
    question: "What's your fashion philosophy?",
    option1: "Flirty and feminine with confidence wrapped in charm",
    option1Celeb: "Sabrina Carpenter",
    option2: "Dark and daring, dressing for myself, not for the trends",
    option2Celeb: "Jenna Ortega",
    option3:
      "Quality over quantity with timeless pieces that never go out of style",
    option3Celeb: "Alexandra Saint Mleux",
    option4: "Go big or go home, fashion is about having fun and taking risks",
    option4Celeb: "Katseye",
  },
];
